module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Bold-WebM-ef576a3617e7d78bf072ca28fac9ec27.woff2";